<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:rest.rests') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:rest.rest') })"
            icon2="delete"
            @clickedButton2="deleteRest"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editRest"
            @clickedAddButton="editRest"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <RestForm
        @updateTable="updateTableAfterManipulation"
        ref="restForm" />

  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import RestForm from '@/modules/settings/views/settings/rest-external/RestExternalForm.vue';
import RestService from '@/modules/settings/services/rest-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Rest from '@/modules/settings/data/rest';

export default {
  name: "RestExternalTable",
  components: {
    RestForm,
    DataTablePaginated
  },
  data() {
    return {
      rest: new Rest(),
      rests: []
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:user'), value: 'username'},
        {text: this.$t('settings/settings:rest.token'), value: 'token'},
        {text: this.$t('settings/settings:rest.webpage'), value: 'webpage'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      RestService.readAllRestsPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Rest);
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:rest.rest')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editRest(rest) {
      this.$refs.restForm.initialization(rest);
    },
    deleteRest(rest) {
      RestService.deleteRest(rest.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('settings/settings:rest.rest')}));
            this.updateTableAfterManipulation();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('settings/settings:rest.rest')}));
          }
      );
    }
  }
}
</script>